import {
  HANDOFF,
  HANDOFF_BUSY,
  HANDOFF_ERROR,
  HANDOFF_SUCCESS,
  HANDOFF_TIMEOUT,
  HANDOFF_UPDATE_KIOSK_CART,
  HANDOFF_RESET_KIOSK_CART,
} from './constants';

export const handoff = cartId => ({
  type: HANDOFF,
  payload: {
    cartId,
  },
});

export const handoffUpdateKioskCart = cartId => ({
  type: HANDOFF_UPDATE_KIOSK_CART,
  payload: {
    cartId,
  },
});

export const handoffResetKioskCart = () => ({
  type: HANDOFF_RESET_KIOSK_CART,
});

export const handoffBusy = () => ({
  type: HANDOFF_BUSY,
});

export const handoffSuccess = payload => ({
  type: HANDOFF_SUCCESS,
  payload,
});

export const handoffError = () => ({
  type: HANDOFF_ERROR,
});

export const handoffTimeout = () => ({
  type: HANDOFF_TIMEOUT,
});
